// JsFromRoutes CacheKey d42a2de79e84f89d69007b4206d8734f
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  autocomplete: /* #__PURE__ */ definePathHelper('get', '/cities/autocomplete'),
}
